import { frontendURL } from '../../../../helper/URLHelper';
import { ROLES } from 'dashboard/constants/permissions.js';
import SettingsContent from '../Wrapper.vue';
import EvolutionDashboard from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/evolution'),
      component: SettingsContent,
      props: {
        headerTitle: 'Conexões WhatsApp',
        icon: 'i-lucide-phone',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'evolution_dashboard',
          component: EvolutionDashboard,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
